import React from "react";
import "./HelpSection.css";
import { FaCalendarAlt, FaPhoneAlt, FaUsers } from "react-icons/fa";
import { Link } from "react-router-dom";

const HelpSection = () => {
  return (
    <div className="help-container" id="contactus">
      <h2 className="help-title">We are Here to Help You</h2>
      <p className="help-subtitle">
        We’re ready to help out in your time of financial need.
      </p>

      <div className="help-cards">
        <div className="help-card">
          <FaCalendarAlt className="help-icon" />
          <h3>APPLY FOR LOAN</h3>
          <p>Looking to buy a car or home loan? then apply for loan now.</p>
          <a
            href="https://respectedsolution.com/"
            target="blank"
            className="help-link"
          >
            Get Appointment
          </a>
        </div>

        <div className="help-card">
          <FaPhoneAlt className="help-icon" />
          <h3>CALL US AT</h3>
          <p>
            <a href="tel:+2349037614599" className="phone-link">
              09037614599
            </a>
            <br />
            <a
              href="https://wa.me/2349114351195"
              target="_blank"
              rel="noopener noreferrer"
              className="phone-link"
            >
              WhatsApp +234 911 435 1195
            </a>
            <br />
            <a href="mailto:info@respectedsolution.co" className="email-link">
              info@respectedsolution.co
            </a>
          </p>
          <Link
            to="/contact-us"
            onClick={() => setMenuOpen(false)}
            className="help-link"
          >
            Contact Us
          </Link>
        </div>

        <div className="help-card">
          <FaUsers className="help-icon" />
          <h3>TALK TO ADVISOR</h3>
          <p>Need loan advise? Talk to our loan advisors.</p>
          <a href="/money-advice" className="help-link">
            Meet The Advisor
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpSection;
